AgrimarketServices.service('ceremisApiService', ['$rootScope', '$http', '$location', 'configurationFactory',
    function ($rootScope, $http, $location, configurationFactory) {

        var SendRequest = function (configfile, callback) {
            $http(configfile)
                .success(function (data) {
                    callback(data, null, null, null);
                })
                .error(function (data, status, headers, config) {
                    callback(data, status, headers, config);
                });
        };

        this.GetOffersCeremis = function (idExtCrop, callback) {
            var config = {
                method: 'get',
                url: configurationFactory.Url['Api'] + 'CeremisApi/GetOffersCeremis',
                params: {
                    idExtCrop: idExtCrop
                }
            };

            SendRequest(config, callback);
        };

        this.GetCeremisStrikes = function (idExpiryWsd, idTypeOption, callback) {
            var config = {
                method: 'get',
                url: configurationFactory.Url['Api'] + 'CeremisApi/GetCeremisStrikes',
                params: {
                    idExpiryWsd: idExpiryWsd,
                    idTypeOption: idTypeOption
                }
            };

            SendRequest(config, callback);
        };

    }]);